// globals
const $ = jQuery;
const $window = $(window);

// native selectors
const paragraphTabs = '.paragraph--tabs';
const tabLink = '.paragraph-tabs__tab-link';
const tabLinks = '.paragraph-tabs__tab-links';
const tabContent = '.paragraph-tabs__field-item';
const tabsContainer = '.paragraph-tabs__field-items';
const tabLinksContainer = '.paragraph-tabs__tab-links-container';
const paragraphTabsItem = '.paragraph-tabs__field-tabs-item';

// classes
const paragraphTabLinkActiveClass = 'paragraph-tabs__tab-link--active';
const paragraphTabContentActiveClass =
  'paragraph-tabs__field-item--active-content';
const tabContentTransitionClass = 'paragraph-tabs__field-item--transition';
const linkToLeft = 'paragraph-tabs__tab-link--to-left';
const linkToRight = 'paragraph-tabs__tab-link--to-right';
const scrollStartClass = 'scroll--start';
const scrollEndClass = 'scroll--end';

// jquery selectors
const $tabLink = $(tabLink);
const $tabLinks = $(tabLinks);
const $tabLinksContainer = $(tabLinksContainer);
const $elementTabs = $('.element-tabs');

// on load display the first tab as active
const showFirstOnLoad = () => {
  $.each($(paragraphTabs), function showOnLoad() {
    const $this = $(this);
    $this
      .find(tabLinks)
      .children()
      .first()
      .addClass(paragraphTabLinkActiveClass);
    const $tabContentActive = $this.find(tabsContainer).children().first();

    $tabContentActive.addClass(paragraphTabContentActiveClass);
  });
};

const toggleActiveTab = () => {
  $tabLink.on('click', function tabLinkClick(e) {
    const $this = $(this);
    e.stopImmediatePropagation();
    e.preventDefault();

    // Toggle content display
    const $parent = $this.parents(paragraphTabs);
    const $currentActive = $parent.find(`.${paragraphTabContentActiveClass}`);
    const $content = $parent.find(tabContent);
    const activeId = $this.attr('data-tab');
    const minHeight = $currentActive.outerHeight();

    $content.addClass(tabContentTransitionClass);

    $parent.find(paragraphTabsItem).css({
      'min-height': minHeight,
    });

    const activeClasses = setTimeout(() => {
      clearTimeout(activeClasses);
      $content.removeClass(paragraphTabContentActiveClass);
      $(activeId).addClass(paragraphTabContentActiveClass);
    }, 401);

    const transitionClass = setTimeout(() => {
      clearTimeout(transitionClass);
      $content.removeClass(tabContentTransitionClass);
      $parent.find(paragraphTabsItem).css({
        'min-height': 0,
      });
    }, 402);

    // Figure out which element was clicked
    // to determine the animation
    const $oldTab = $parent.find(`div.${paragraphTabLinkActiveClass}`);
    const oldIndex = $oldTab.index();
    const thisIndex = $this.index();

    if (oldIndex < thisIndex) {
      $oldTab.addClass(linkToLeft);
      $oldTab.removeClass(paragraphTabLinkActiveClass);
      $this.addClass(linkToRight);

      setTimeout(() => {
        $this.addClass(paragraphTabLinkActiveClass);
      }, 400);
    } else if (oldIndex > thisIndex) {
      $oldTab.addClass(linkToRight);
      $oldTab.removeClass(paragraphTabLinkActiveClass);
      $this.addClass(linkToLeft);

      setTimeout(() => {
        $this.addClass(paragraphTabLinkActiveClass);
      }, 400);
    }

    setTimeout(function waitForLoad() {
      $parent.find(tabLink).removeClass(`${linkToRight} ${linkToLeft}`);
    }, 400);

    // remove active class from not clicked tabs
    setTimeout(() => {
      $parent.find(tabLink).not($this).removeClass(paragraphTabLinkActiveClass);
      $this.addClass(paragraphTabLinkActiveClass);
    }, 400);
  });
};

$.fn.overflown = function checkOverflow() {
  const e = this[0];
  return e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth;
};

// Adds gradient on links container borders
// if there are too many links to fit on one row
const initScroll = () => {
  const overflows = $tabLinks.overflown();

  !overflows
    ? $tabLinksContainer.removeClass(scrollStartClass)
    : $tabLinksContainer.addClass(scrollStartClass);
};

$tabLinks.on('scroll', function onScroll() {
  const curr = $(this).scrollLeft();

  if (curr === 0) {
    $tabLinksContainer.addClass(scrollStartClass).removeClass(scrollEndClass);
  } else {
    const max = Math.round(
      $(this)[0].scrollWidth - $(this).parent().outerWidth(),
    );

    if (curr === max) {
      $tabLinksContainer.addClass(scrollEndClass).removeClass(scrollStartClass);
    } else {
      $tabLinksContainer.addClass(`${scrollStartClass} ${scrollEndClass}`);
    }
  }
});

if ($elementTabs.length > 0) {
  $window.on('resize', () => {
    initScroll();
  });
}

(() => {
  if ($elementTabs.length > 0) {
    toggleActiveTab();
    initScroll();
  }
})();

/**
 * Disable animations on page load and enable them 100ms after.
 * This is necessary because the browser needs some time to
 * render the page and calculate the scroll position.
 */
let onLoadTimer;
// @todo check if all this still necessary
document.addEventListener('DOMContentLoaded', () => {
  if ($elementTabs.length > 0) {
    // Add a class to the body to disable animations
    document.body.classList.add('resize-animation-stopper');

    // Clear the timer if it was set
    clearTimeout(onLoadTimer);

    // Set a new timer to remove the class
    onLoadTimer = setTimeout(() => {
      document.body.classList.remove('resize-animation-stopper');
    }, 100);

    // Make the first tab active on page load
    showFirstOnLoad();
  }
});
